
export const loginHubConsumeMock = {
	successConsume: async (token: string): Promise<boolean> => {
		console.log(`Authenticating with ${token}`);
		return true;
	},
};
